import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';

import './App.css';

import ModalRoot from './components/Modals/ModalRoot';
import Home from './components/Home/Home';
import Navigation from './components/Navigation/Navigation';
import Wizard from './components/Wizard/Wizard';
import Help from './components/Home/Help';
import Projects from './components/Projects/Projects';
import Archive from './components/Projects/Archive';
import Project from './components/Project/Project';
import Documentations from './components/Documentations/Documentations';
import Documentation from './components/Documentations/Documentation';
import ProjectBasics from './components/Project/ProjectBasics';
import ProjectContact from './components/Project/ProjectContact';
import ProjectCustomer from './components/Project/ProjectCustomer';
import ProjectHelp from './components/Project/ProjectHelp';
import Register from './components/Auth/Register';
import RegisterVerification from './components/Auth/RegisterVerification';
import Login from './components/Auth/Login';
import PasswordForgotten from './components/Auth/PasswordForgotten';
import RecreatePassword from './components/Auth/RecreatePassword';
import Profile from './components/User/Profile';
import Settings from './components/User/Settings';
import ChangePassword from './components/User/ChangePassword';
import Participations from './components/User/Participations';
import EliminateAccount from './components/User/EliminateAccount';
import AccessToken from './components/User/AccessToken';
import Impress from './components/Impress';
import Datenschutz from './components/Datenschutz';
import RevitPlugin from './components/RevitPlugin';
import TermsOfUse from './components/TermsOfUse';

import {
  useLocation
} from "react-router-dom";


import * as actions from './store/actions/index';
import { ROUTES } from './routes';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const App = () => {

  const dispatch = useDispatch();
  let query = useQuery();
  const ref = document.referrer

  const trackedKeys = ['pst', 'tst'];
  const trackedValues = ['k1h2', '2rhde2'];

  // count calls with params for stats
  useEffect(() => {
    let q = "";
    trackedKeys.forEach( (key) => {
      q = (query !== null)? query.get(key) : "";
      if (trackedValues.includes(q)){
        dispatch( actions.eventFirstVisit(key, q) )
      }
    })
  }, []);

  // count direct call (without referrer)
  useEffect(() => {
    let q = "";
    let hasParam = false;

    trackedKeys.forEach( (key) => {
      q = (query !== null)? query.get(key) : "";
      if (trackedValues.includes(q)){
        hasParam = true;
      }
    })

    if ((ref.includes('productselector.de') || ref === "") && !hasParam ){
      dispatch( actions.eventDirectVisit() )
    }
  }, []);


  useEffect(() => { dispatch( actions.authCheckState() )}, []);
  useEffect(() => {
      document.title = "Rudolf Hensel | Product Selector"
    }, [])

  const hideModal = () => {dispatch( hideModal() )};
  const showModal = (modalProps, modalType) => {
    dispatch(showModal({ modalProps, modalType }))
  }

  const isAuthenticated = useSelector(state => state.auth.token !== null);

  let routes = (
    <Switch>
      <Route exact path="/"><Login /></Route>
      <Route path={ROUTES.TO_WIZARD}><Wizard /></Route>
      <Route path={ROUTES.TO_HELP}><Help /></Route>
      <Route path={ROUTES.TO_REGISTER}><Register /></Route>
      <Route path={ROUTES.TO_LOGIN}><Login /></Route>
      <Route path={ROUTES.TO_PASSWORD_FORGOTTEN}><PasswordForgotten /></Route>
      <Route path={ROUTES.TO_IMPRESSUM}><Impress /></Route>
      <Route path={ROUTES.TO_DATENSCHUTZ}><Datenschutz /></Route>
      <Route path={ROUTES.TO_REVIT_PLUGIN}><RevitPlugin /></Route>
      <Route path={ROUTES.TO_TERMS_OF_USE}><TermsOfUse /></Route>
      <Route path={ROUTES.TO_REGISTER_VERIFICATION}><RegisterVerification /></Route>
      <Route path={ROUTES.TO_RECREATE_PASSWORD}><RecreatePassword /></Route>
      <Redirect to="/" />
    </Switch>
  );

  if ( isAuthenticated ) {
    routes = (
      <Switch>
        <Route exact path="/"><Home /></Route>
        <Route path={ROUTES.TO_ARCHIVE}><Archive /></Route>
        <Route exact path={ROUTES.TO_PROJECTS}><Projects /></Route>
        <Route path={ROUTES.TO_WIZARD}><Wizard /></Route>
        <Route exact path={ROUTES.TO_DOCUMENTATIONS}><Documentations /></Route>
        <Route path={ROUTES.TO_DOCUMENTATION()}><Documentation /></Route>
        <Route path={ROUTES.TO_PROJECT_BASICS()}><ProjectBasics /></Route>
        <Route path={ROUTES.TO_PROJECT_CONTACT()}><ProjectContact /></Route>
        <Route path={ROUTES.TO_PROJECT_CUSTOMER()}><ProjectCustomer /></Route>
        <Route path={ROUTES.TO_PROJECT_HELP()}><ProjectHelp /></Route>
        <Route path={ROUTES.TO_PROJECT()}><Project /></Route>
        <Route path={ROUTES.TO_HELP}><Help /></Route>
        <Route exact path={ROUTES.TO_ACCOUNT}><Profile /></Route>
        <Route exact path={ROUTES.TO_SETTINGS}><Settings /></Route>
        <Route exact path={ROUTES.TO_CHANGE_PASSWORD}><ChangePassword /></Route>
        <Route exact path={ROUTES.TO_PARTICIPATIONS}><Participations /></Route>
        <Route exact path={ROUTES.TO_ELIMINATE_ACCOUNT}><EliminateAccount /></Route>
        <Route path={ROUTES.TO_MANAGE_ACCESS_TOKEN}><AccessToken /></Route>
        <Route path={ROUTES.TO_IMPRESSUM}><Impress /></Route>
        <Route path={ROUTES.TO_DATENSCHUTZ}><Datenschutz /></Route>
        <Route path={ROUTES.TO_REVIT_PLUGIN}><RevitPlugin /></Route>
        <Route path={ROUTES.TO_TERMS_OF_USE}><TermsOfUse /></Route>
        <Redirect to="/" />
      </Switch>
    );
  }

  return (

    <div className="layout layout-nav-side">

      <Navigation isAuthenticated={isAuthenticated} />

      <div className="main-container">
        {routes}
      </div>
      <ModalRoot />
    </div>

  )

}


export default App;



// WEBPACK FOOTER //
// ./src/App.js